import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const AboutPage = () => {
  return (
    <main className="min-h-screen bg-white pt-16" data-testid="about-page">
      <SEO
        title="Povestea Noastră"
        url="https://seltz.eu/about"
        description="Află povestea Seltz. Băutura născută în București, din dorința de a crea băutura perfectă, fără compromisuri la calitate. Seltz este un lifestyle."
      />
      {/* Hero */}
      <section className="bg-[#0a0a0a] py-20 sm:py-28">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1
            className="text-white font-black italic leading-tight mb-6"
            style={{
              fontFamily: 'Nunito, sans-serif',
              fontSize: 'clamp(2.5rem, 6vw, 4.5rem)',
            }}
          >
            born in Bucharest
          </h1>
          <p
            className="text-white/70 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            Seltz s-a născut din dorința de a crea băutura perfectă - light, cu gust autentic de fructe și prospețime.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose max-w-none">
            <p
              className="text-gray-700 text-base sm:text-lg leading-relaxed mb-8"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              Seltz este băutura ta pentru fiecare ocazie. Creată pentru cei care vor să se distreze, dar fără compromisuri la calitate sau gust. Nu am creat doar o băutură. Am creat un lifestyle.
            </p>
          </div>
        </div>
      </section>

      {/* De ce Seltz? */}
      <section className="py-16 sm:py-20 bg-[#0a0a0a]">
        <div className="max-w-5xl mx-auto px-6">
          <h2
            className="text-white font-black italic text-3xl sm:text-4xl text-center mb-12"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            de ce Seltz?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: 'natural flavours', desc: 'Arome naturale autentice din ingrediente selectate cu grijă' },
              { title: 'premium vodka', desc: 'Distilată fin, netedă și rafinată până la perfecțiune' },
              { title: 'bold taste', desc: 'Creată din ingrediente de calitate pentru un gust delicios și intens' },
              { title: 'low calories', desc: '86 de calorii, fără gluten' },
            ].map((item) => (
              <div key={item.title} className="border border-white/10 rounded-2xl p-6 text-center">
                <h3 className="text-white font-black italic text-lg mb-2" style={{ fontFamily: 'Nunito, sans-serif' }}>
                  {item.title}
                </h3>
                <p className="text-white/50 text-sm" style={{ fontFamily: 'Nunito, sans-serif' }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Specs */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <h2
            className="text-[#0a0a0a] font-black italic text-3xl text-center mb-10"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            în fiecare doză
          </h2>
          <div className="grid grid-cols-3 gap-6">
            {[
              { value: '5%', label: 'alcool' },
              { value: '86', label: 'calorii' },
              { value: '250ml', label: 'per doză' },
            ].map((spec) => (
              <div key={spec.label} className="text-center">
                <p className="text-[#0a0a0a] font-black italic text-4xl sm:text-5xl mb-1" style={{ fontFamily: 'Nunito, sans-serif' }}>
                  {spec.value}
                </p>
                <p className="text-gray-400 text-sm font-semibold" style={{ fontFamily: 'Nunito, sans-serif' }}>
                  {spec.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#0a0a0a] text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="text-white font-black italic text-2xl sm:text-3xl mb-6" style={{ fontFamily: 'Nunito, sans-serif' }}>
            încearcă Seltz astăzi
          </h2>
          <Link
            to="/shop"
            className="inline-block bg-white text-[#0a0a0a] font-black italic text-base px-10 py-4 rounded-full hover:bg-gray-100 transition-all hover:scale-105 shadow-xl"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            cumpără acum
          </Link>
        </div>
      </section>
    </main>
  );
};

export default AboutPage;
